export default "__VITE_ASSET___dj8RpQT__"